import axios from 'axios'
import {toHttpError} from './httpError'
import {getToken} from '../services/utils.js'
import ApiAuth from "../services/auth";

const baseUrl = process.env.REACT_APP_API + "/api/v1"
const apiAuth = ApiAuth()

let refreshPromise = null
const isAuthRequest = (cfg) =>
  /\/openid-connect\/token|\/refresh|\/logout/i.test(
    cfg?.url || '',
  )
const logoutLocal = () => {
  localStorage.clear()
  window.location.href = '/'
}

export const api = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
  signal: undefined,
})

api.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }

  if (config.data instanceof FormData) {
    if (config.headers) {
      delete config.headers['Content-Type']
      delete config.headers['content-type']
    }
  } else {
    config.headers = config.headers || {}
    if (!config.headers['Content-Type'] && !config.headers['content-type']) {
      config.headers['Content-Type'] = 'application/json'
    }
  }

  return config
})

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const httpErr = toHttpError(error)
    const originalConfig = error?.config || {}

    if (
      httpErr.status === 0 &&
      httpErr.code === 'NETWORK_ERROR'
    ) {
      try {
        logoutLocal()

        if (window.location.pathname !== "/erro-sistema") {
          const url = new URL("/erro-sistema", window.location.origin);
          window.location.replace(url.toString());
        }
      } catch (e) {
        console.warn("Falha ao processar 0:", e);
      }
      return Promise.reject(httpErr);
    }

    if ((httpErr.status === 403 || httpErr.status === 406) && !originalConfig.skipAuthError) {
      try {
        try {
          if (httpErr.status === 406) {
            await apiAuth.logout()
          } else {
            logoutLocal()
          }
        } catch (e) {}

        if (window.location.pathname !== "/acesso-negado") {
          window.location.href = '/acesso-negado'
        }
      } catch (e) {
        console.warn(`Falha ao processar ${httpErr.status}: `, e);
      }
      return Promise.reject(httpErr);
    }

    if (httpErr.status === 409) {
      try {
        logoutLocal()
        localStorage.setItem('error', '409')
        window.location.href = '/acesso-negado'

      } catch (e) {
        console.warn(`Falha ao processar ${httpErr.status}: `, e);
      }
      return Promise.reject(httpErr)
    }

    if (
      httpErr.status === 401 &&
      !originalConfig._retry &&
      !isAuthRequest(originalConfig)
    ) {
      try {
        if (!refreshPromise) {
          refreshPromise = apiAuth
            .refreshToken()
            .finally(() => (refreshPromise = null))
        }
        await refreshPromise

        originalConfig._retry = true
        originalConfig.headers = originalConfig.headers || {}
        originalConfig.headers.Authorization = `Bearer ${getToken()}`
        return api.request(originalConfig)
      } catch (e) {
        console.warn(e)
        await ApiAuth().logout()
        return Promise.reject(httpErr)
      }
    }

    return Promise.reject(httpErr)
  },
)

export async function get(url, { params, signal } = {}) {
  const res = await api.get(url, { params, signal })
  return res.data
}
export async function post(url, body, { params, signal, headers } = {}) {
  const res = await api.post(url, body, { params, signal, headers })
  return res.data
}
export async function put(url, body, { params, signal } = {}) {
  const res = await api.put(url, body, { params, signal })
  return res.data
}
export async function patch(url, body, { params, signal } = {}) {
  const res = await api.patch(url, body, { params, signal })
  return res.data
}
export async function del(url, { params, signal } = {}) {
  const res = await api.delete(url, { params, signal })
  return res.data
}
